module.exports = __webpack_public_path__ + "img/activities-3.565eab3a.jpg";